
function get(route, Dataparams) {
    return jQuery.ajax({
        url: window.LSFrontendAjax.ajaxurl,
        type: 'GET',
        data: {
            ...Dataparams,
            action: 'ls_ajax_get',
            route_name: route
        }
    })
}

function post(route, Dataparams) {

    let isFormData = {
        processData: false,
        contentType: false
    };

    // Check if Dataparams is a FormData object
    if (Dataparams instanceof FormData) {
        Dataparams.append('action', 'ls_ajax_post');
        Dataparams.append('route_name', route);
        Dataparams.append('_ajax_nonce', window.LSFrontendAjax._ajax_nonce); 

    } else {
        // Regular data object
        Dataparams = {
            ...Dataparams,
            action: 'ls_ajax_post',
            _ajax_nonce: window.LSFrontendAjax._ajax_nonce,
            route_name: route
        };
    }


    return jQuery.ajax({
        url: window.ajaxurl || window.LSFrontendAjax.ajaxurl,
        type: 'POST',
        data: Dataparams,
        ...(Dataparams instanceof FormData) ? isFormData : {}
    });
}

export { get, post } 